(function () {
  'use strict';

  /* Collection filters: apply on change */
  var filterForm = document.querySelector('[data-filter-form]');
  if (filterForm) {
    var submitFilters = function () {
      var params = new URLSearchParams();
      new FormData(filterForm).forEach(function (value, key) {
        if (value !== '') params.append(key, value);
      });
      var sort = document.querySelector('[data-sort]');
      if (sort) params.set('sort_by', sort.value);
      window.location.search = params.toString();
    };
    var timer;
    filterForm.addEventListener('change', function (e) {
      clearTimeout(timer);
      timer = setTimeout(submitFilters, e.target.type === 'number' ? 600 : 0);
    });
    var sortSelect = document.querySelector('[data-sort]');
    if (sortSelect) sortSelect.addEventListener('change', submitFilters);
  }

  /* Localization selectors: submit on change */
  document.querySelectorAll('[data-localization-select]').forEach(function (sel) {
    sel.addEventListener('change', function () { sel.form.submit(); });
  });

  /* Cart quantities: save on change */
  document.querySelectorAll('[data-cart-qty]').forEach(function (input) {
    input.addEventListener('change', function () {
      var form = input.form;
      var flag = document.createElement('input');
      flag.type = 'hidden';
      flag.name = 'update';
      flag.value = '1';
      form.appendChild(flag);
      form.submit();
    });
  });

  /* Product: variant selection */
  var section = document.querySelector('[data-product-section]');
  if (!section) return;
  var jsonEl = section.querySelector('[data-product-json]');
  var form = section.querySelector('[data-product-form]') || document.getElementById('ProductForm');
  if (!jsonEl || !form) return;
  var S = window.themeStrings || {};
  var product = JSON.parse(jsonEl.textContent);
  var idInput = form.querySelector('[data-variant-id]');
  var addBtn = form.querySelector('[data-add]');
  var priceEls = section.querySelectorAll('[data-price]');
  var stickyBtn = section.querySelector('[data-add-sticky]');

  function money(cents) {
    var fmt = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: fmt }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  function selectedOptions() {
    return Array.prototype.map.call(section.querySelectorAll('.option'), function (fs) {
      var checked = fs.querySelector('input:checked');
      return checked ? checked.value : null;
    });
  }

  function findVariant(opts) {
    return product.variants.find(function (v) {
      return v.options.every(function (o, i) { return o === opts[i]; });
    });
  }

  function valueAvailable(idx, value) {
    return product.variants.some(function (v) { return v.available && v.options[idx] === value; });
  }

  function markAvailability(opts) {
    section.querySelectorAll('.option').forEach(function (fs, idx) {
      fs.querySelectorAll('input').forEach(function (input) {
        var test = opts.slice();
        test[idx] = input.value;
        var v = findVariant(test);
        var off = v ? !v.available : !valueAvailable(idx, input.value);
        input.closest('.pill').classList.toggle('is-unavailable', off);
      });
    });
  }

  /* When a choice has no exact match (e.g. a scrunchie style while size S is picked),
     resolve to the closest variant with that value: available first, then keep as many
     other current/last-picked options as possible. */
  var lastPicked = selectedOptions();
  function resolve(changedIdx) {
    var opts = selectedOptions();
    var exact = findVariant(opts);
    if (exact) return; /* exact match (even if sold out) is shown as is */
    var value = opts[changedIdx];
    var best = null, bestScore = -1;
    product.variants.forEach(function (v) {
      if (v.options[changedIdx] !== value) return;
      var score = v.available ? 1000 : 0;
      v.options.forEach(function (o, i) {
        if (i === changedIdx) return;
        if (o === opts[i]) score += 10;
        if (o === lastPicked[i]) score += 1;
      });
      if (score > bestScore) { best = v; bestScore = score; }
    });
    if (!best || best === exact) return;
    section.querySelectorAll('.option').forEach(function (fs, idx) {
      if (idx === changedIdx) return;
      var target = best.options[idx];
      Array.prototype.forEach.call(fs.querySelectorAll('input'), function (i) {
        i.checked = i.value === target;
      });
    });
  }

  function update(e) {
    if (e && e.target && e.target.closest) {
      var fsEl = e.target.closest('.option');
      var cIdx = fsEl ? Array.prototype.indexOf.call(section.querySelectorAll('.option'), fsEl) : -1;
      if (cIdx > -1 && !(window.PIS_finderClearing)) {
        lastPicked[cIdx] = e.target.value;
        resolve(cIdx);
      }
    }
    var opts = selectedOptions();
    section.querySelectorAll('.option').forEach(function (fs, idx) {
      var label = fs.querySelector('[data-option-selected]');
      if (label) label.textContent = opts[idx] || '';
    });
    markAvailability(opts);
    var variant = findVariant(opts);
    if (!variant) {
      idInput.value = "";
      addBtn.disabled = true;
      addBtn.textContent = S.unavailable || 'Unavailable';
      if (stickyBtn) { stickyBtn.disabled = true; stickyBtn.textContent = addBtn.textContent; }
      return;
    }
    idInput.value = variant.id;
    addBtn.disabled = !variant.available;
    addBtn.textContent = variant.available ? (addBtn.getAttribute('data-add-label') || S.addToCart || 'Add to cart') : (S.soldOut || 'Sold out');
    if (stickyBtn) { stickyBtn.disabled = addBtn.disabled; stickyBtn.textContent = addBtn.textContent; }
    if (priceEls.length) {
      var html = '';
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        html += '<s class="price__compare">' + money(variant.compare_at_price) + '</s>';
      }
      html += '<span class="price__now">' + money(variant.price) + '</span>';
      priceEls.forEach(function (el) { el.innerHTML = html; });
    }
    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());
  }

  section.querySelectorAll('.option input').forEach(function (input) {
    input.addEventListener('change', update);
  });
  if (section.querySelector('.option')) markAvailability(selectedOptions());

  /* Size finder out of chart range: clear the size and swap Add to cart for an email link */
  var emailBtn = null;
  function setSizingEmail(on) {
    if (on && !emailBtn) {
      emailBtn = document.createElement('a');
      emailBtn.className = addBtn.className;
      emailBtn.setAttribute('data-size-email', '');
      emailBtn.href = 'mailto:support@pawsinstyles.com?subject=' + encodeURIComponent('Sizing help: ' + (product.title || ''));
      emailBtn.textContent = S.emailSizing || 'Email us for sizing';
      emailBtn.style.textAlign = 'center';
      addBtn.insertAdjacentElement('afterend', emailBtn);
    }
    if (emailBtn) emailBtn.style.display = on ? '' : 'none';
    addBtn.style.display = on ? 'none' : '';
    if (stickyBtn) stickyBtn.style.display = on ? 'none' : '';
    var pay = form.querySelector('.shopify-payment-button');
    if (pay) pay.style.display = on ? 'none' : '';
  }
  window.PIS_sizeOutOfRange = function (sizeIndex) {
    var fs = section.querySelector('.option[data-option-index="' + sizeIndex + '"]');
    if (!fs) return;
    var inputs = fs.querySelectorAll('input');
    Array.prototype.forEach.call(inputs, function (i) { i.checked = false; });
    window.PIS_finderClearing = true;
    try { if (inputs[0]) inputs[0].dispatchEvent(new Event('change', { bubbles: true })); } finally { window.PIS_finderClearing = false; }
    setSizingEmail(true);
  };
  section.addEventListener('change', function (e) {
    if (window.PIS_finderClearing) return;
    if (e.target && e.target.closest && e.target.closest('.option') && e.target.checked) setSizingEmail(false);
  });

  /* Size finder */
  var finder = section.querySelector('[data-size-finder]');
  if (finder) {
    var ranges = (finder.getAttribute('data-map') || '').split(',').map(function (part) {
      var m = part.trim().match(/^(.+?)\s*:\s*([\d.]+)\s*-\s*([\d.]+)$/);
      return m ? { size: m[1].trim(), min: parseFloat(m[2]), max: parseFloat(m[3]) } : null;
    }).filter(Boolean);
    var sizeIndex = parseInt(finder.getAttribute('data-size-index'), 10);
    var weightInput = finder.querySelector('[data-finder-weight]');
    var unitSelect = finder.querySelector('[data-finder-unit]');
    var result = finder.querySelector('[data-finder-result]');

    var runFinder = function () {
      var w = parseFloat(weightInput.value);
      if (isNaN(w) || w <= 0) {
        result.textContent = S.finderEmpty || 'Enter your pet’s weight to get a size.';
        return;
      }
      var lb = unitSelect.value === 'kg' ? w * 2.20462 : w;
      var match = ranges.find(function (r) { return lb >= r.min && lb < r.max; });
      if (!match) {
        window.PIS_sizeOutOfRange(sizeIndex);
        result.textContent = S.finderOutOfRange || 'That’s outside our size chart. Email us and we’ll help you pick.';
        return;
      }
      var fieldset = section.querySelector('.option[data-option-index="' + sizeIndex + '"]');
      var radio = fieldset && Array.prototype.find.call(fieldset.querySelectorAll('input'), function (i) {
        return i.value.toLowerCase() === match.size.toLowerCase();
      });
      if (radio) {
        radio.checked = true;
        update();
        setSizingEmail(false);
        var v = findVariant(selectedOptions());
        result.textContent = ((v && !v.available) ? (S.finderSoldOut || 'We recommend size __SIZE__ (sold out in this color).') : (S.finderResult || 'We recommend size __SIZE__.')).replace('__SIZE__', radio.value);
      } else {
        result.textContent = (S.finderNotOffered || 'We recommend size __SIZE__.').replace('__SIZE__', match.size);
      }
    };
    finder.querySelector('[data-finder-go]').addEventListener('click', runFinder);
    weightInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); runFinder(); }
    });
  }
})();

/* Slideshow */
(function () {
  'use strict';
  document.querySelectorAll('[data-slideshow]').forEach(function (root) {
    var slides = root.querySelectorAll('.slide');
    var dots = root.querySelectorAll('[data-slide-to]');
    if (slides.length < 2) return;
    var i = 0, timer = null;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var auto = root.getAttribute('data-autoplay') === 'true' && !reduce;
    var speed = (parseInt(root.getAttribute('data-speed'), 10) || 6) * 1000;
    var pauseBtn = root.querySelector('[data-slide-pause]');
    var paused = false;

    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) {
        var on = k === i;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
        s.querySelectorAll('a').forEach(function (a) { a.tabIndex = on ? 0 : -1; });
      });
      dots.forEach(function (d, k) {
        d.classList.toggle('is-active', k === i);
        if (k === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
      });
    }
    function start() { stop(); if (auto && !paused) timer = setInterval(function () { go(i + 1); }, speed); }
    function stop() { if (timer) clearInterval(timer); timer = null; }

    var prev = root.querySelector('[data-slide-prev]');
    var next = root.querySelector('[data-slide-next]');
    if (prev) prev.addEventListener('click', function () { go(i - 1); start(); });
    if (next) next.addEventListener('click', function () { go(i + 1); start(); });
    dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-slide-to'), 10)); start(); }); });
    if (pauseBtn) pauseBtn.addEventListener('click', function () {
      paused = !paused;
      pauseBtn.setAttribute('aria-pressed', paused ? 'true' : 'false');
      var TS = window.themeStrings || {};
      pauseBtn.setAttribute('aria-label', paused ? (TS.play || 'Play slideshow') : (TS.pause || 'Pause slideshow'));
      if (paused) stop(); else start();
    });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);

    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) { go(i + (dx < 0 ? 1 : -1)); start(); }
      x0 = null;
    });

    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:block:select', function (e) {
        var idx = Array.prototype.indexOf.call(slides, e.target);
        if (idx > -1) { stop(); go(idx); }
      });
    }
    start();
  });
})();

/* Tabs + product rails */
(function () {
  'use strict';
  document.querySelectorAll('[data-tabs]').forEach(function (root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    var panels = root.querySelectorAll('[role="tabpanel"]');
    function select(t) {
      tabs.forEach(function (x, k) {
        var on = x === t;
        x.setAttribute('aria-selected', on ? 'true' : 'false');
        x.tabIndex = on ? 0 : -1;
        panels[k].hidden = !on;
      });
    }
    tabs.forEach(function (t, k) {
      t.addEventListener('click', function () { select(t); });
      t.addEventListener('keydown', function (e) {
        var n = null;
        if (e.key === 'ArrowRight') n = tabs[(k + 1) % tabs.length];
        if (e.key === 'ArrowLeft') n = tabs[(k - 1 + tabs.length) % tabs.length];
        if (n) { e.preventDefault(); select(n); n.focus(); }
      });
    });
    function activeRail() {
      var p = Array.prototype.find.call(panels, function (x) { return !x.hidden; });
      return p && p.querySelector('[data-rail]');
    }
    function scroll(dir) {
      var r = activeRail();
      if (r) r.scrollBy({ left: dir * r.clientWidth * 0.9, behavior: 'smooth' });
    }
    var prev = root.querySelector('[data-rail-prev]');
    var next = root.querySelector('[data-rail-next]');
    if (prev) prev.addEventListener('click', function () { scroll(-1); });
    if (next) next.addEventListener('click', function () { scroll(1); });
  });
})();

/* Mobile menu drawer */
(function () {
  'use strict';
  document.querySelectorAll('[data-drawer-open]').forEach(function (btn) {
    var dlg = document.getElementById(btn.getAttribute('data-drawer-open'));
    if (!dlg || typeof dlg.showModal !== 'function') return;
    btn.addEventListener('click', function () {
      dlg.showModal();
      btn.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('no-scroll');
    });
    dlg.addEventListener('close', function () {
      btn.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('no-scroll');
      btn.focus();
    });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    dlg.querySelectorAll('[data-drawer-close]').forEach(function (c) { c.addEventListener('click', function () { dlg.close(); }); });
  });
})();

/* Mobile filter sheet */
(function () {
  'use strict';
  var drawer = document.querySelector('[data-filter-drawer]');
  var openBtn = document.querySelector('[data-filter-open]');
  if (!drawer || !openBtn) return;
  function open() {
    drawer.classList.add('is-open');
    openBtn.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('no-scroll');
    var c = drawer.querySelector('[data-filter-close]');
    if (c) c.focus();
  }
  function close() {
    drawer.classList.remove('is-open');
    openBtn.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('no-scroll');
    openBtn.focus();
  }
  openBtn.addEventListener('click', open);
  drawer.querySelectorAll('[data-filter-close]').forEach(function (b) { b.addEventListener('click', close); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) close(); });
  try {
    if (sessionStorage.getItem('filtersOpen') === '1' && window.matchMedia('(max-width: 989px)').matches) open();
    sessionStorage.removeItem('filtersOpen');
  } catch (e) {}
  drawer.addEventListener('change', function () {
    try { if (drawer.classList.contains('is-open')) sessionStorage.setItem('filtersOpen', '1'); } catch (e) {}
  });
})();

/* Sticky add to cart (mobile) */
(function () {
  'use strict';
  var bar = document.querySelector('[data-sticky-atc]');
  var main = document.querySelector('[data-add]');
  if (!bar || !main || !('IntersectionObserver' in window)) return;
  bar.hidden = false;
  new IntersectionObserver(function (entries) {
    var e = entries[0];
    var below = e.boundingClientRect.top < 0;
    bar.classList.toggle('is-visible', !e.isIntersecting && below);
  }).observe(main);
})();

